<script>
import { SectionHeading } from "@/shared/ui/section-heading";

export default {
  name: "UserSettingRight",
  components: { SectionHeading },
  props: {},
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<template>
  <div
    class="p-8 h-full overflow-auto bg-white rounded-2xl flex flex-col gap-6"
  >
    <!-- Header -->
    <SectionHeading
      :title="$t('Настройка прав')"
      :description="$t('Настройка прав')"
      title-class="text-xl"
    />
  </div>
</template>

<style scoped lang="scss"></style>
